module.exports = __webpack_public_path__ + "img/small-word-02.8cd173f4.png";